import { db } from '@/firebase'

const employeeRef = db.collection('employees')

export default {
  state: {
    isEmployeeBtnLoading: false
  },
  mutations: {
    toggleEmployeeBtnLoading (state, payload) {
      if (payload === undefined || payload === null) {
        state.isEmployeeBtnLoading = !state.isEmployeeBtnLoading
      } else {
        state.isEmployeeBtnLoading = payload
      }
    }
  },
  actions: {
    createEmployee ({ commit }, payload) {
      return employeeRef.add(payload)
    },
    getEmployees () {
      return employeeRef.get()
    },
    getActiveEmployees () {
      return employeeRef.where('isActive', '==', true).get()
    },
    getEmployee ({ commit }, id) {
      return employeeRef.doc(id).get()
    },
    updateEmployee ({ commit }, { id, ...payload }) {
      return employeeRef.doc(id).set(payload, { merge: true })
    }
  },
  getters: {
    isEmployeeBtnLoading: (state) => state.isEmployeeBtnLoading
  }
}
